(async () => {
  if (!customElements.get('ugc-overview')) {
    const { Fancybox } = await import('@fancyapps/ui');

    class UgcOverview extends HTMLElement {
      constructor() {
        super();

        this.options = {};

        // Check if we have extra options on the HTML
        if (this.dataset?.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.options = {
              ...this.options,
              ...jsonOptions,
            };
          }
        }
      }

      connectedCallback() {
        this.target = document.querySelector('[data-ugc-target]');
        this.template = document.getElementById('ugc-template').innerHTML;
        this.button = document.querySelector('[data-ugc-button]');

        // Start pagination
        this.page = 1;

        // Set event listener
        this.button.addEventListener('click', () => {
          this.page++;
          this.fetchUgc(this.page);
        });

        // Fetch the first page
        this.fetchUgc(1);
      }

      // Function to fetch the UGC from the API
      fetchUgc(page) {
        let url =
          'https://api.reviews.io/instagram/widget?transform_data=true&per_page=36&includeVideos=false&orderBy=date_desc&enable_syndication=true&store=' +
          this.options.store_id;

        // Add pagination
        if (page) {
          url += '&page=' + page;
        }

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            this.renderData(data);
          });
      }

      // Function to render the UGC result
      renderData(data) {
        // If no more results are available, hide the button
        if (data.timeline.length === 0) {
          // Hide the button to load more
          this.button.classList.remove('block');
          this.button.classList.add('hidden');
          return;
        }

        // create the html
        let html = '';
        data.timeline?.forEach((ugc) => {
          // Create a smaller thumbnail then the default
          let customUgc = {};
          customUgc.thumbnail = ugc._source.image_sm[0].image.replace('/500?', '/360?').replace('width=500', 'width=360');
          customUgc.image = ugc._source.image[0].image;
          customUgc.author = ugc._source.author;
          customUgc.comments = ugc._source.comments;
          customUgc.human_date = ugc._source.human_date;
          customUgc.title = ugc._source?.tagged_products[0]?.product?.name || '';
          customUgc.link = ugc._source?.tagged_products[0]?.product?.link || '';

          let template = this.template;

          // If no link, remove any links and hide the button and product name
          if (customUgc.link == '') {
            template = template
              .replace('a href="{link}"', 'span')
              .replace('</a>', '</span>')
              .replace('product-link', 'product-link hidden')
              .replace('button', 'button hidden');
          }

          // Replace the placeholders in the template with the values from the ugc
          html += template.replace(
            /\{(.*?)\}/g,
            function (match, p1) {
              const path = p1;
              const value = this.getObjectPath(customUgc, path);
              return value;
            }.bind(this)
          );
        });

        // Append the html string to the target
        this.target.insertAdjacentHTML('beforeend', html);

        // Show the button to load more
        this.button.classList.remove('hidden');
        this.button.classList.add('block');

        // bind fancybox to the images
        this.bindFancybox();
      }

      // Function to bind Fancybox to the images
      bindFancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        // bind fancybox to the images
        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'fancybox-ugc',
          autoFocus: false,
        });
      }

      // Function to get a nested object property by using a variable path string as a key
      getObjectPath(obj, path) {
        return path.split('.').reduce((o, p) => {
          if (o) {
            if (Number.isInteger(parseInt(p)) && Array.isArray(o)) {
              return o[parseInt(p)];
            } else {
              return o[p];
            }
          } else {
            return null;
          }
        }, obj);
      }
    }

    window.UgcOverview = UgcOverview;
    customElements.define('ugc-overview', UgcOverview);
  }
})();
